import React from 'react';
import { styled } from '@mui/material';
import { FileItem, getFileUrl, getMediaType } from 'src/utils/fileUploadUtils';

interface MediaRendererProps {
  file: FileItem;
  onClick?: () => void;
}

const MediaRenderer = ({ file, onClick }: MediaRendererProps) => {
  const mediaUrl = getFileUrl(file.value);
  const mimeType = getMediaType(file.value);

  if (!mediaUrl) return null;

  if (mimeType.startsWith('video/')) {
    return (
      <MediaContainer onClick={onClick}>
        <StyledVideo key={file.id} controls draggable={false} playsInline>
          <source src={mediaUrl} type={mimeType} />
        </StyledVideo>
      </MediaContainer>
    );
  }

  return (
    <MediaContainer onClick={onClick}>
      <StyledImage src={mediaUrl} alt="preview" />
    </MediaContainer>
  );
};

export default MediaRenderer;

const MediaContainer = styled('div')(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
}));

const StyledVideo = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
});
const StyledImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
});
